import { createApi } from '@reduxjs/toolkit/query/react'
import getQuery from '../../helpers/api/get-query'
import RewindQueueEntry from '../../types/api/rewind-queue-entry'
import Strapi, {
    EndpointQueryParameters,
    StrapiCreate,
    StrapiSingle,
    StrapiUpdate,
} from '../../types/strapi/strapi'
import getCustomFetchBase from '../custom-fetch-base'

export const rewindQueueEntriesApi = createApi({
    reducerPath: 'rewindQueueEntriesApi',
    baseQuery: getCustomFetchBase({ baseUrl: import.meta.env.VITE_API_URL }),
    tagTypes: ['RewindQueueEntries'],
    endpoints: builder => ({
        getRewindQueueEntries: builder.query<
            Strapi<RewindQueueEntry>,
            EndpointQueryParameters | void
        >({
            query: getQuery('/rewind-queue-entries'),
            providesTags: ['RewindQueueEntries'],
        }),
        createRewindQueueEntry: builder.mutation<
            StrapiSingle<RewindQueueEntry>,
            StrapiCreate<RewindQueueEntry>
        >({
            query: body => ({
                url: '/rewind-queue-entries',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['RewindQueueEntries'],
        }),
        updateRewindQueueEntry: builder.mutation<
            StrapiSingle<RewindQueueEntry>,
            StrapiUpdate<RewindQueueEntry>
        >({
            query: ({ docId, body }) => ({
                url: `/rewind-queue-entries/${docId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['RewindQueueEntries'],
        }),
        reorderRewindQueueEntries: builder.mutation<
            unknown,
            { data: Pick<RewindQueueEntry, 'documentId' | 'sort'>[] }
        >({
            query: body => ({
                url: '/rewind-queue-entries/reorder',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['RewindQueueEntries'],
        }),
        deleteRewindQueueEntry: builder.mutation<void, string>({
            query: docId => ({
                url: `/rewind-queue-entries/${docId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['RewindQueueEntries'],
        }),
    }),
})

export const {
    useGetRewindQueueEntriesQuery,
    useLazyGetRewindQueueEntriesQuery,
    useCreateRewindQueueEntryMutation,
    useUpdateRewindQueueEntryMutation,
    useReorderRewindQueueEntriesMutation,
    useDeleteRewindQueueEntryMutation,
} = rewindQueueEntriesApi
